import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'
import { commonFeedActions } from '../FeedsTabContent/actions'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export default function DeleteMessageConfirmation({
  type,
  stats,
  messageId,
  deleteMessage,
  closeModal,
  organizationId,
  workplaceIds
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const getCurrentQuantity = () => {
    if (stats) {
      return stats.nextOffset < appConstantSettings.PAGINATION_QUANTITY
        ? appConstantSettings.PAGINATION_QUANTITY
        : stats.nextOffset
    } else {
      return appConstantSettings.PAGINATION_QUANTITY
    }
  }

  const {
    commonNewsfeed: { deleteFeed },
    common: { isMobile }
  } = useSelector((state) => state)

  const [deleteConfirmed, setDeleteConfirmed] = useState(false)

  const handleDeleteMessage = () => {
    if (messageId && messageId > 0) {
      dispatch(commonFeedActions.deleteFeed(messageId, getCurrentQuantity(), organizationId, workplaceIds))
      setDeleteConfirmed(true)
    }
  }
  useEffect(() => {
    if (!deleteFeed.loading && deleteFeed.success && deleteConfirmed) {
      closeModal()
    }
  }, [deleteFeed.success, deleteFeed.loading, deleteConfirmed])

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('messenger.chatWindow.deleteMessageConfirmationTitle')}</h1>
      <h2 className={styles.warning}>{t('messenger.chatWindow.deleteMessageConfirmationWarning')}</h2>
      <div className={styles.buttonWrapper}>
        <Button
          size='large'
          handleClick={closeModal}
          style='tertiary'
          text={isMobile ? t('messenger.no') : t('messenger.btnCancel')}
        />
        <Button
          size='large'
          text={
            deleteFeed.loading ? (
              <Spinner isWhite={true} customCss={styles.spinner} />
            ) : isMobile ? (
              t('messenger.yes')
            ) : (
              t('messenger.btnDoIt')
            )
          }
          handleClick={handleDeleteMessage}
        />
      </div>
    </div>
  )
}
